import { normalize_time } from 'console/tabs/graphs/components/graph/sources/common';
import * as lodash from 'lodash';
const shallow_array_equal = (a, b) => {
    if (a === b) {
        return true;
    }
    if (a.length !== b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
};
export function memoize_by_first_arg(calc_func, delete_func) {
    const last_by_key = {};
    return (key, ...args) => {
        const s_key = key?.toString() ?? 'null';
        const last = last_by_key[s_key];
        if (last != null && shallow_array_equal(last.args, args))
            return last.result;
        if (last != null && delete_func != null)
            delete_func(last.result);
        const result = calc_func(key, ...args);
        last_by_key[s_key] = { args, result };
        return result;
    };
}
export function memoize_by_first_arg2(calc_func, delete_func) {
    const last_by_key = {};
    return ((key, ...args) => {
        const s_key = key?.toString() ?? 'null';
        const last = last_by_key[s_key];
        //Если по этому ключу кто-то есть, то сравниваем входные аргументы
        if (last != null && lodash.isEqual(last.args, args)) {
            return last.result;
        }
        if (last != null && delete_func != null) {
            delete_func(last.result);
        }
        const result = calc_func(key, ...args);
        last_by_key[s_key] = { args, result };
        return result;
    });
}
export function extend_timed_array(array = [], new_values = [], mintime, maxtime, time_index) {
    // may return original array if there is no new data
    const in_range = new_values.filter((item) => mintime <= item[time_index] && item[time_index] <= maxtime);
    // console.log('extend_timed_array', 'in_range', in_range);
    if (in_range.length === 0)
        return array;
    return normalize_time([...array, ...in_range], time_index).sort((a, b) => a[0] - b[0]);
}
function setter_not_empty(original, setter) {
    // check if setter has at least one changed field
    for (const [k, v] of Object.entries(setter ?? {}))
        if (v !== original[k])
            return true;
    return false;
}
export function lazy_apply_setter(original, setter) {
    // apply setter only if it is needed
    if (setter_not_empty(original, setter))
        return { ...original, ...setter };
    else
        return original;
}
export function mergeNewData(existing, new_data, mintime, maxtime, only = null) {
    const data_setter = {};
    const should_update = (key) => only == null || only.includes(key);
    if (new_data.gps != null && should_update('gps'))
        data_setter.gps = extend_timed_array(existing != null ? existing.gps : [], new_data.gps, mintime, maxtime, 0);
    if (new_data.events != null && should_update('events'))
        data_setter.events = extend_timed_array(existing != null ? existing.events : [], new_data.events, mintime, maxtime, 1);
    const result = lazy_apply_setter(existing ?? {}, data_setter);
    return result;
}
